import {PWMAT_RESOURCE} from './consts'

export const ModuleClass = [
  {
    name: '1. Combined with active learning: PWmat_MLFF extended application MLFF on the fly',
    url: 'https://mp.weixin.qq.com/s/4MXeBHojatqoAWAcGp946w',
  },
  {
    name: '2. “Light” is bizarre: PWmat calculates optical properties (Part 3)',
    url: 'https://mp.weixin.qq.com/s/URFZYjX1iHFp2T-m-7LkZw',
  },
  {
    name: '3. “Light” is bizarre: PWmat calculates optical properties (Part 2)',
    url: 'https://mp.weixin.qq.com/s/NfLL1Ex4Zajlrj0QZiPjKQ',
  },
  {
    name: '4. “Light” is bizarre: PWmat calculates optical properties (I)',
    url: 'https://mp.weixin.qq.com/s/mtrAPVbTMqB9npEpqV_cmA',
  },
  {
    name: '5. A brief discussion on the understanding of gap: the module for correcting gap in PWmat',
    url: 'https://mp.weixin.qq.com/s/9jkQ9u58g949gfK94FMw3g',
  },
  {
    name: '6. Introduction to the principles and application examples of the high-end, atmospheric and upscale CPM method',
    url: 'https://mp.weixin.qq.com/s/NCRQX5OqCMTCR02H1FvTTg',
  },
  {
    name: '7. Calculation method of U value in LDA+U',
    url: 'https://mp.weixin.qq.com/s/xMCSsHJMFNn3nCM6jSx05A',
  },
  {
    name: '8. Important research results of high-k gate stacks',
    url: 'https://mp.weixin.qq.com/s/pKxb9vslOWNe5uMC3HlI-A',
  },
  {
    name: '9. A method for calculating charged defects that is independent of semiconductor dimensions',
    url: 'https://mp.weixin.qq.com/s/zROfXW8VThopMS0v7yUT3w',
  },
  {
    name: '10. Pourbaix Diagram calculation',
    url: 'https://mp.weixin.qq.com/s/CqmB3PKtP3NnRj2p9J9oiA',
  },
  {
    name: '11. PWmat calculation of charge trapping process at the interface between crystalline silicon and amorphous silicon',
    url: 'https://mp.weixin.qq.com/s/w8entgtW-_vxW9ivEJhEeg',
  },
  {
    name: '12. Wannier Koopmans Method to correct LDA band gap',
    url: 'https://mp.weixin.qq.com/s/5ZXBO6LxDAUrg-EZggIqMw',
  },
  {
    name: '13. NAMD studies ultrafast hot carrier injection in Au/GaN system',
    url: 'https://mp.weixin.qq.com/s/LZZEttScCo8kAZlf2C40sw',
  },
  {
    name: '14. Calculation ideas of PWmat fixed-potential method',
    url: 'https://mp.weixin.qq.com/s/ssNGXChznpNiPABJAJR5Lw',
  },
  {
    name: '15. WKM method accurately calculates the band structure of two-dimensional materials',
    url: 'https://mp.weixin.qq.com/s/flfDEpLrHt94i7jRjhzZgA',
  },
  {
    name: '16. Non-adiabatic molecular dynamics (NAMD) study of hot carrier relaxation and transfer processes in quantum dots',
    url: 'https://mp.weixin.qq.com/s/IecSYcfh-DBUSdTUV85Gaw',
  },
  {
    name: '17. Wannier-Koopmans method (WKM) for calculating the band gap of organic molecular crystals',
    url: 'https://mp.weixin.qq.com/s/P41fTj-oI4q8ldo9eFuCvA',
  },
  {
    name: '18. Calculation of phonon spectra of some atoms in crystals, defect systems and supercells',
    url: 'https://mp.weixin.qq.com/s/vqHbVbZGMMnZZFsr2Fpnlw',
  },
  {
    name: '19. PWmat module introduction - disorder',
    url: 'https://mp.weixin.qq.com/s/fOphldP_k1lt7-wfg5-bow',
  },
  {
    name: '20. Complete ORR catalytic calculation using PWmat',
    url: 'https://mp.weixin.qq.com/s/haVZFvYVLMmgWwqaXjVbkA',
  },
  {
    name: '21. PWmat’s lattice thermal conductivity calculation module',
    url: 'https://mp.weixin.qq.com/s/Z4NLfg8WqIGFysxv5tZt7g',
  },
  {
    name: '22. PWmat - DeePMD-kit interface for deep learning',
    url: 'https://mp.weixin.qq.com/s/JTwU-dEtBYxALQTYgMGkqA',
  },
  {
    name: '23. PWmat module introduction - PLUMED',
    url: 'https://mp.weixin.qq.com/s/2pq8qkg_Kr7b43EKgGVOOg',
  },
  {
    name: '24. Heat Transport Module of PWmat',
    url: 'https://mp.weixin.qq.com/s/aGIFo88rGuJNMhl_LIciHA',
  },
  {
    name: '25. PWmat module introduction - BSE calculation',
    url: 'https://mp.weixin.qq.com/s/LsrJug8FKZRSeRwgin9teQ',
  },
  {
    name: '26. Teach you how to calculate charge capture using PWmat',
    url: 'https://mp.weixin.qq.com/s/KUqp63W8itQIOjxi38wvAA',
  },
  {
    name: '27. Teach you how to use PWmat to calculate OER, ORR, and HER reactions',
    url: 'https://mp.weixin.qq.com/s/FI5VnpgT3Wa2KO5uKqFVYA',
  },
  {
    name: '28. PWmat launches a metal system conductivity calculation module',
    url: 'https://mp.weixin.qq.com/s/V3DbrFu5HGohpl8IqYQDSw',
  },
  {
    name: '29. PWmat\'s powerful tool - Charge Patching Method for large system calculations',
    url: 'https://mp.weixin.qq.com/s/XwvkMElHgWRjhMLvFcrHrw',
  },
  {
    name: '30. PWmat\'s Defect Nonradiative Decay calculation module',
    url: 'https://mp.weixin.qq.com/s/B_t3cVwJR895sq-jzIk9FA',
  },
  {
    name: "31. PWmat's rt-TDDFT module simulates ultrafast dynamics",
    url: 'https://mp.weixin.qq.com/s/aoaguhLXxgp1nvLuYrGXEg',
  },
  {
    name: '32. PWmat calculation of defect energy levels',
    url: 'https://mp.weixin.qq.com/s/dRfy7o_KZslzt3kAyCrK7g',
  },
  {
    name: '33. PWmat adds multiple new NEB algorithms and CI-NEB support',
    url: 'https://mp.weixin.qq.com/s/5_1Vd8DqN-eaJDmIZE2t7Q',
  },
  {
    name: '34. PWmat adds SCAN+rVV10 function',
    url: 'https://mp.weixin.qq.com/s/gtyJNfWI8H4wPDjcMa9KAw',
  },
  {
    name: '35. PWmat supports molecular dynamics of NPT systems',
    url: 'https://mp.weixin.qq.com/s/v5b2cN-e3Z8g0J0T5jNSAw',
  },
  {
    name: '36. PWmat launches high-throughput elastic constant calculation module ELPWmat',
    url: 'https://mp.weixin.qq.com/s/_WgjQQ9YmSMKQDLkScdnIQ',
  },
  {
    name: '37. PWmat implements HSE+SOC function',
    url: 'https://mp.weixin.qq.com/s/W1IAwHvzOPNlTkCmN8wz2A',
  },
  {
    name: '38. PWmat calculation process of energy band order',
    url: 'https://mp.weixin.qq.com/s/5r4teJNfcE3cMXKtEq3wcQ',
  },
  {
    name: '39. PWmat launches exclusive pseudopotential—ONCV-PWM-PBE mode conservation pseudopotential',
    url: 'https://mp.weixin.qq.com/s/y4xXZ5W3bRYezk_LYSo_mg',
  },
  {
    name: '40. PWmat realizes fast calculation of HSE for large systems',
    url: 'https://mp.weixin.qq.com/s/zIfmHgV_cKlmrVhImOKcyg',
  },
  {
    name: '41. Improving atomic relaxation speed using PWmat',
    url: 'https://mp.weixin.qq.com/s/Bx-q5V2gsnNqxEeJYI2dpw',
  },
  {
    name: '42. PWmat Functional Module-Solvent Model',
    url: 'https://mp.weixin.qq.com/s/PZ-an4-DIfemiBtCSZQgxw',
  },
  {
    name: '43. Use PWmat to complete the electroacoustic coupling calculation',
    url: 'https://mp.weixin.qq.com/s/FrYnFL0GUeWsc8X9yJ2H4w',
  },
  {
    name: '44. PWmat+CALYPSO interface application example',
    url: 'https://mp.weixin.qq.com/s/86le9shChRVhKMiUSiWRGw',
  },
  {
    name: '45. PWmat phonon spectrum calculation example',
    url: 'https://mp.weixin.qq.com/s/qtt1ax6OX4SxkuCUqaepkw',
  },
  {
    name: '46. ​​PWmat+Wannier.90 accurately calculates band gap',
    url: 'https://mp.weixin.qq.com/s/0vaXYZlWITlcIXOOdOsR3A',
  },
  {
    name: "47. PWmat's rt-TDDFT module studies collision problems",
    url: 'https://mp.weixin.qq.com/s/wIrr1Nlq-r7t0S3rnDYwuA',
  }

]


